var React = require('react');

function CircuitCornerBR (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-100 -570)"},[React.createElement("path",{"d":"M-454,115h20l30-30V65","transform":"translate(554 505)","fill":"none","stroke":"#eace00","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M-474,105h30l40-40V35","transform":"translate(574 535)","fill":"none","stroke":"#eace00","strokeWidth":"4","key":1})]));
}

CircuitCornerBR.defaultProps = {"width":"72","height":"72","viewBox":"0 0 72 72"};

module.exports = CircuitCornerBR;

CircuitCornerBR.default = CircuitCornerBR;
